import * as React from "react";
import { useEffect, useRef } from "react";
import { TextInput, ButtonIcon } from "@traceair/tds";
import { style } from "typestyle";
import HidePasswordIcon from "../../../assets/svg/hide-password.svg";
import ShowPasswordIcon from "../../../assets/svg/show-password.svg";

interface IPasswordInputProps {
  onChange: (value: string) => void;
  value: string;
  placeholder: string;
  title: string;
  errorMessage?: string | undefined;
  isInvalid?: boolean;
  shouldBeFocused?: boolean;
  onBlur?: () => void;
  onFocus?: () => void;
  showLengthAlert?: boolean;
  className?: string;
  isWarning?: boolean;
  warningMessage?: string;
  disabled?: boolean;
}

const PasswordInput = ({
  onChange,
  value,
  placeholder,
  title,
  errorMessage,
  isInvalid,
  shouldBeFocused,
  onBlur,
  onFocus,
  className,
  isWarning,
  warningMessage,
  disabled
}: IPasswordInputProps) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [isFocused, setFocus] = React.useState(shouldBeFocused || false);
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (shouldBeFocused) {
      focusInput();
    }
  }, []);

  const focusInput = () => {
    ref.current?.focus();
  };

  return (
    <div
      onBlur={() => {
        setFocus(false);
        onBlur && onBlur();
      }}
      onFocus={() => {
        setFocus(true);
        onFocus && onFocus();
      }}
      onTouchStart={() => {
        setFocus(true);
      }}
    >
      <TextInput
        ref={ref}
        onChange={value => {
          onChange && onChange(value);
        }}
        type={showPassword ? "text" : "password"}
        value={value}
        placeholder={placeholder}
        label={title}
        className={className}
        hidePlaceholderOnFocus
        rightCell={
          <ButtonIcon
            tabIndex={-1}
            size="xs"
            type={"white"}
            onClick={() => {
              focusInput();
              setShowPassword(!showPassword);
            }}
            className={style({
              background: "none !important"
            })}
            icon={
              <img
                className={style({
                  visibility: isFocused ? "visible" : "hidden"
                })}
                src={showPassword ? HidePasswordIcon : ShowPasswordIcon}
                alt={"password"}
              />
            }
          />
        }
        errorMessage={errorMessage ? errorMessage : undefined}
        isError={isInvalid}
        isWarning={isWarning}
        warningMessage={warningMessage}
        disabled={disabled}
      />
    </div>
  );
};

export default PasswordInput;
